const initLoadMore = () => {
  const loadMoreEls = document.querySelectorAll('[data-load-more]');
  if (!loadMoreEls.length) return;
  const loadMoreItemsEl = '[data-load-more-items]';

  const initLoadMoreElement = (rootEl) => {
    const itemsCountTextEl = rootEl.querySelector('[data-load-more-count-text]');
    const itemsCountPagedTextEl = itemsCountTextEl?.querySelector('[data-load-more-count-paged]');
    const loadMoreButton = rootEl.querySelector('[data-load-more-button]');
    const loadingSpinner = rootEl.querySelector('[data-loading-spinner]');

    let loading = false;

    const setLoading = (isLoading) => {
      loading = isLoading;
      loadMoreButton?.classList.toggle('loading', isLoading);
      loadingSpinner?.classList.toggle('hidden', !isLoading);
    };

    const loadNextPage = async () => {
      if (!loadMoreButton || loading) return;

      setLoading(true);
      try {
        const response = await fetch(loadMoreButton.href);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const parsedLoadMoreContainer = parsed.querySelector(loadMoreItemsEl);
        const ogLoadMoreContainer = document.querySelector(loadMoreItemsEl);
        const newLoadMoreEl = parsed.querySelector('[data-load-more]');
        const newItems = [...parsedLoadMoreContainer.children];

        newItems.forEach((child) => ogLoadMoreContainer.append(child.cloneNode(true)));

        if (itemsCountPagedTextEl) {
          itemsCountPagedTextEl.textContent = ogLoadMoreContainer.children.length;
        }

        if (newLoadMoreEl) {
          const newButton = newLoadMoreEl.querySelector('[data-load-more-button]');
          if (newButton) loadMoreButton.href = newButton.href;
        } else {
          loadMoreButton.remove();
        }
      } catch (err) {
        console.error('Error during loading products:', err);
      } finally {
        setLoading(false);
      }
    };

    const handleButtonClick = (e) => {
      e.preventDefault();
      loadNextPage();
    };
    loadMoreButton?.addEventListener('click', handleButtonClick);
  };
  loadMoreEls.forEach(initLoadMoreElement);
};

export default initLoadMore;
